// components/Hero/AuctionCard.tsx
import React from "react";
import { motion } from "framer-motion";

interface AuctionCardProps {
  isAr: boolean;
}

export const AuctionCard: React.FC<AuctionCardProps> = ({ isAr }) => (
  <motion.div
    animate={{ y: [0, -10, 0] }}
    transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
    className={`absolute bottom-[8%] ${isAr ? "left-[-4%]" : "right-[-4%]"} w-[260px] bg-[#0A0C12]/85 backdrop-blur-[24px] border border-[#C8A96E]/25 rounded-2xl p-6 shadow-[0_32px_64px_rgba(0,0,0,0.5)] z-10`}
  >
    <div className="flex items-center gap-2 mb-3.5">
      <div className="w-2 h-2 rounded-full bg-[#4ADE80] shadow-[0_0_8px_#4ADE80] animate-pulse" />
      <span className="text-[11px] text-[#EDE5D6]/45 tracking-[1.5px] uppercase font-cairo">
        {isAr ? "مباشر الآن" : "Live Now"}
      </span>
    </div>
    <div className="text-[13px] text-[#EDE5D6] font-semibold mb-1">
      {isAr ? "مزاد تمويل عقاري" : "Mortgage Auction"}
    </div>
    <div className="text-[12px] text-[#EDE5D6]/45 mb-3.5">
      {isAr ? "برج رافال — الرياض" : "Rafal Tower — Riyadh"}
    </div>
    <div className="w-full h-1 bg-[#EDE5D6]/10 rounded-full overflow-hidden">
      <motion.div
        initial={{ width: "0%" }}
        animate={{ width: "75%" }}
        transition={{ duration: 2, delay: 0.5, ease: "easeOut" }}
        className="h-full bg-gradient-to-r from-[#C8A96E] to-[#F0D080] rounded-full"
      />
    </div>
    <div className="mt-1.5 text-[10px] text-[#EDE5D6]/45 flex justify-between font-cairo">
      <span>{isAr ? "تغطية بنكية" : "Bank Coverage"}: 75%</span>
      <span className="text-[#C8A96E]">{isAr ? "نشط" : "Active"}</span>
    </div>
  </motion.div>
);
